import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Reviews Banner Saga ***************************
export function* fetchReviewsBannerSaga(action) {
  try {
    yield put(Creators.fetchReviewsBannerStart());
    const url = yield apiEndpoints.reviewsPageBanner;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const reviewsBannerData = [];
    if (res.data.success === 1) {
      for (let key in res.data.Banner) {
        reviewsBannerData.push({
          id: key,
          ...res.data.Banner[key]
        });
      }
    }
    // console.log('reviewsBannerData: ', reviewsBannerData);
    yield put(Creators.fetchReviewsBannerSuccess(reviewsBannerData));
  } catch (err) {
    yield put(
      Creators.fetchReviewsBannerFailure(err => {
        console.log('err: ', err);
      })
    );
  }
}
// ______________________________________________________________________________

// *************************** Fetch Latest Reviews Saga ***************************
export function* fetchLatestReviewsSaga(action) {
  try {
    yield put(Creators.fetchLatestReviewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.latestReviews;
    } else {
      url = yield `${apiEndpoints.latestReviews}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const latestReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        latestReviews.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    // console.log('latestReviews: ', latestReviews);
    yield put(
      Creators.fetchLatestReviewsSuccess({
        pageNumber: action.pageNumber,
        latestReviews: latestReviews
      })
    );
  } catch (err) {
    yield put(
      Creators.fetchLatestReviewsFailure(err => {
        console.log('err: ', err);
      })
    );
  }
}
// ______________________________________________________________________________

// *************************** Fetch Top Reviews Saga ***************************
export function* fetchTopReviewsSaga(action) {
  try {
    yield put(Creators.fetchTopReviewsStart());
    const url = yield apiEndpoints.topReviews;
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const topReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        topReviews.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    // console.log('topReviews: ', topReviews);
    yield put(Creators.fetchTopReviewsSuccess(topReviews));
  } catch (err) {
    yield put(Creators.fetchTopReviewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Laptops Saga ***************************
export function* fetchLaptopsSaga(action) {
  try {
    yield put(Creators.fetchLaptopsStart());
    const url = yield apiEndpoints.laptops;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const laptops = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        laptops.push({
          id: key,
          ...res.data.categoryPosts[key]
        });
      }
    }
    // console.log('laptops: ', laptops);
    yield put(Creators.fetchLaptopsSuccess(laptops));
  } catch (err) {
    yield put(Creators.fetchLaptopsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Mobiles Saga ***************************
export function* fetchMobilesSaga(action) {
  try {
    yield put(Creators.fetchMobilesStart());
    const url = yield apiEndpoints.mobiles;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const mobiles = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        mobiles.push({
          id: key,
          ...res.data.categoryPosts[key]
        });
      }
    }
    // console.log('mobiles: ', mobiles);
    yield put(Creators.fetchMobilesSuccess(mobiles));
  } catch (err) {
    yield put(Creators.fetchMobilesFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Cameras Saga ***************************
export function* fetchCamerasSaga(action) {
  try {
    yield put(Creators.fetchCamerasStart());
    const url = yield apiEndpoints.cameras;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const cameras = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        cameras.push({
          id: key,
          ...res.data.categoryPosts[key]
        });
      }
    }
    // console.log('cameras: ', cameras);
    yield put(Creators.fetchCamerasSuccess(cameras));
  } catch (err) {
    yield put(Creators.fetchCamerasFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Accessories Saga ***************************
export function* fetchAccessoriesSaga(action) {
  try {
    yield put(Creators.fetchAccessoriesStart());
    const url = yield apiEndpoints.accessories;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const accessories = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        accessories.push({
          id: key,
          ...res.data.categoryPosts[key]
        });
      }
    }
    // console.log('accessories: ', accessories);
    yield put(Creators.fetchAccessoriesSuccess(accessories));
  } catch (err) {
    yield put(Creators.fetchAccessoriesFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Best Of Laptops Saga ***************************
export function* fetchBestOfLaptopsSaga(action) {
  try {
    yield put(Creators.fetchBestOfLaptopsStart());
    const url = yield apiEndpoints.bestOfLaptops;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bestOfLaptops = [];
    if (res.data.success === 1) {
      for (let key in res.data.bestOf) {
        bestOfLaptops.push({
          id: key,
          ...res.data.bestOf[key]
        });
      }
    }
    // console.log('bestOfLaptops: ', bestOfLaptops);
    yield put(Creators.fetchBestOfLaptopsSuccess(bestOfLaptops));
  } catch (err) {
    yield put(Creators.fetchBestOfLaptopsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Best Of Mobiles Saga ***************************
export function* fetchBestOfMobilesSaga(action) {
  try {
    yield put(Creators.fetchBestOfMobilesStart());
    const url = yield apiEndpoints.bestOfMobiles;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bestOfMobiles = [];
    if (res.data.success === 1) {
      for (let key in res.data.bestOf) {
        bestOfMobiles.push({
          id: key,
          ...res.data.bestOf[key]
        });
      }
    }
    // console.log('bestOfMobiles: ', bestOfMobiles);
    yield put(Creators.fetchBestOfMobilesSuccess(bestOfMobiles));
  } catch (err) {
    yield put(Creators.fetchBestOfMobilesFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Best Of Cameras Saga ***************************
export function* fetchBestOfCamerasSaga(action) {
  try {
    yield put(Creators.fetchBestOfCamerasStart());
    const url = yield apiEndpoints.bestOfCameras;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bestOfCameras = [];
    if (res.data.success === 1) {
      for (let key in res.data.bestOf) {
        bestOfCameras.push({
          id: key,
          ...res.data.bestOf[key]
        });
      }
    }
    // console.log('bestOfCameras: ', bestOfCameras);
    yield put(Creators.fetchBestOfCamerasSuccess(bestOfCameras));
  } catch (err) {
    yield put(Creators.fetchBestOfCamerasFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Best Of Accessories Saga ***************************
export function* fetchBestOfAccessoriesSaga(action) {
  try {
    yield put(Creators.fetchBestOfAccessoriesStart());
    const url = yield apiEndpoints.bestOfAccessories;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bestOfAccessories = [];
    if (res.data.success === 1) {
      for (let key in res.data.bestOf) {
        bestOfAccessories.push({
          id: key,
          ...res.data.bestOf[key]
        });
      }
    }
    // console.log('bestOfAccessories: ', bestOfAccessories);
    yield put(Creators.fetchBestOfAccessoriesSuccess(bestOfAccessories));
  } catch (err) {
    yield put(Creators.fetchBestOfAccessoriesFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Laptops Reviews Saga ***************************
export function* fetchLaptopsReviewsSaga(action) {
  try {
    yield put(Creators.fetchLaptopsReviewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.laptopsReviews;
    } else {
      url = yield `${apiEndpoints.laptopsReviews}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    const laptopsReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        laptopsReviews.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchLaptopsReviewsSuccess({
        pageNumber: action.pageNumber,
        laptopsReviews
      })
    );
  } catch (err) {
    yield put(Creators.fetchLaptopsReviewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Mobiles Reviews Saga ***************************
export function* fetchMobilesReviewsSaga(action) {
  try {
    yield put(Creators.fetchMobilesReviewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.mobilesReviews;
    } else {
      url = yield `${apiEndpoints.mobilesReviews}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    const mobilesReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        mobilesReviews.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchMobilesReviewsSuccess({
        pageNumber: action.pageNumber,
        mobilesReviews
      })
    );
  } catch (err) {
    yield put(Creators.fetchMobilesReviewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Cameras Reviews Saga ***************************
export function* fetchCamerasReviewsSaga(action) {
  try {
    yield put(Creators.fetchCamerasReviewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.camerasReviews;
    } else {
      url = yield `${apiEndpoints.camerasReviews}/page/${action.pageNumber}`;
    }
    const res = yield axios.get(url);
    const camerasReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        camerasReviews.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchCamerasReviewsSuccess({
        pageNumber: action.pageNumber,
        camerasReviews
      })
    );
  } catch (err) {
    yield put(Creators.fetchCamerasReviewsFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Accessories Reviews Saga ***************************
export function* fetchAccessoriesReviewsSaga(action) {
  try {
    yield put(Creators.fetchAccessoriesReviewsStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.accessoriesReviews;
    } else {
      url = yield `${apiEndpoints.accessoriesReviews}/page/${
        action.pageNumber
      }`;
    }
    const res = yield axios.get(url);
    const accessoriesReviews = [];
    if (res.data.success === 1) {
      for (let key in res.data.categoryPosts) {
        accessoriesReviews.push({
          id: res.data.categoryPosts[key].postId,
          ...res.data.categoryPosts[key]
        });
      }
    }
    yield put(
      Creators.fetchAccessoriesReviewsSuccess({
        pageNumber: action.pageNumber,
        accessoriesReviews
      })
    );
  } catch (err) {
    yield put(Creators.fetchAccessoriesReviewsFailure(err));
  }
}
// ______________________________________________________________________________
